import { createApiClient } from './client'
import { DashboardData, DashboardStats, DashboardTrip } from './types'

export interface TripUpdateItem {
  id: string
  type: string
  title: string
  message: string
  actionUrl?: string
  actionText?: string
  metadata?: { tripId?: string; tripName?: string }
  createdAt: string
}

// Dashboard API class - simplified to single endpoint
export class DashboardApi {
  private apiClient: ReturnType<typeof createApiClient>

  constructor(getAuthToken: () => Promise<string | null>) {
    this.apiClient = createApiClient(getAuthToken)
  }

  // Get complete dashboard data - single optimized call
  async getDashboard(): Promise<DashboardData> {
    const response = await this.apiClient.get<{ success: boolean; data: DashboardData }>('/dashboard')
    return response.data
  }

  async getTripUpdates(limit = 15): Promise<TripUpdateItem[]> {
    const response = await this.apiClient.get<{ success: boolean; data: TripUpdateItem[] }>(
      '/dashboard/trip-updates',
      { limit }
    )
    return Array.isArray(response?.data) ? response.data : []
  }
}
